/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData(value) {
    if (!('AccountId' in value) || value['AccountId'] === undefined)
        return false;
    if (!('AccountType' in value) || value['AccountType'] === undefined)
        return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    if (!('AuthToken' in value) || value['AuthToken'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AccountId': json['AccountId'],
        'AccountType': json['AccountType'],
        'GameSystemName': json['GameSystemName'],
        'AuthToken': json['AuthToken'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AccountId': value['AccountId'],
        'AccountType': value['AccountType'],
        'GameSystemName': value['GameSystemName'],
        'AuthToken': value['AuthToken'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersAwAwAuthData.js.map